module.exports = __webpack_public_path__ + "assets/img/system.b742752b.svg";